import React from 'react';
import ReactDOM from 'react-dom';

import './styles/index.css';
import './styles/todo-list.css';
import './styles/filters.css';

import App from './App';

ReactDOM.render(
  <App />,
  document.getElementById('root'),
);
